const clickEvents = {
  addDeliveryInfoButton: {
    pageName: 'checkoutPage',
    buttonName: 'addDeliveryInfo'
  },
  increaseQuantityButton: {
    pageName: 'checkoutPage',
    buttonName: 'increaseQuantity'
  },
  decreaseQuantityButton: {
    pageName: 'checkoutPage',
    buttonName: 'decreaseQuantity'
  },
  showImportFeeButton: {
    pageName: 'checkoutPage',
    buttonName: 'showImportFee'
  },
  showShippingFeeButton: {
    pageName: 'checkoutPage',
    buttonName: 'showShippingFee'
  },
  choosePaymentMethodButton: {
    pageName: 'checkoutPage',
    buttonName: 'choosePaymentMethod'
  },
  agreeToTermsAndConditionsButton: {
    pageName: 'checkoutPage',
    buttonName: 'agreeToTermsAndConditions'
  },
  payNowButton: {
    pageName: 'checkoutPage',
    buttonName: 'payNow'
  }
};

const loadingEvents = {
  checkoutPage: {
    pageName: 'checkoutPage',
    eventName: 'ATF'
  }
};

export default {
  clickEvents,
  loadingEvents
};
